import { Component, OnInit } from '@angular/core';

/**
 * Class for MONISI Terminos y Condiciones page
 */
@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
})
export class TermsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
